import type { ListType } from '@/models/app';
import type { TableColumnType } from '@/models/table';
import { FlaggedUserType } from '@/models/caller';
import { PartnerCodeName } from '@/models/partner';

export const callerTableColumnsInOperatorDB: TableColumnType[] = [
  { label: 'No', field: 'index', width: 60, isCenterAlign: true },
  { label: 'Name', field: 'name', width: 150 },
  { label: 'Caller ID', field: 'id', width: 200 },
  { label: 'Created At', field: 'createdAt', width: 180, isDateField: true },
  { label: 'Active', field: 'isActive', width: 80 },
  { label: 'Deactivation Reason', field: 'deactivationReason', width: 220 },
  { label: 'Birthday', field: 'dob', width: 100 },
  { label: 'Phone Number', field: 'phoneNumber', width: 120 },
  { label: 'Phone Number2', field: 'phoneNumber2', width: 120 },
  { label: 'Home Number', field: 'homeNumber', width: 120 },
  { label: 'Email', field: 'email', width: 200 },
  { label: 'Currency', field: 'currency', width: 90 },
  { label: 'Family Name', field: 'familyName', width: 150 },
  { label: 'Family Email', field: 'familyEmail', width: 150 },
  { label: 'Family PhoneNumber', field: 'familyPhoneNumber', width: 120 },
  { label: 'Street Address', field: 'streetAddress', width: 150 },
  { label: 'Street Address2', field: 'streetAddress2', width: 120 },
  { label: 'City', field: 'city', width: 100 },
  { label: 'State', field: 'state', width: 80 },
  { label: 'Zip', field: 'zip', width: 80 },
  { label: 'Country', field: 'country', width: 90 },
  { label: 'Lat', field: 'latitude', width: 100 },
  { label: 'Lng', field: 'longitude', width: 100 },
  { label: 'customHomeName', field: 'customHomeName', width: 140 },
  { label: 'RideHomeNote', field: 'homeNote', width: 200 },
  { label: 'GourmetHomeNote', field: 'gourmetHomeNote', width: 200 },
  { label: 'TimeZone', field: 'timeZone', width: 160 },
  { label: 'A Name', field: 'aName', width: 100 },
  { label: 'A Phone', field: 'aPhone', width: 100 },
  { label: 'A Location', field: 'aLocation', width: 220 },
  { label: 'A Lat', field: 'aLat', width: 100 },
  { label: 'A Long', field: 'aLong', width: 100 },
  { label: 'A Note', field: 'aNote', width: 150 },
  { label: 'B Name', field: 'bName', width: 100 },
  { label: 'B Phone', field: 'bPhone', width: 100 },
  { label: 'B Location', field: 'bLocation', width: 220 },
  { label: 'B Lat', field: 'bLat', width: 100 },
  { label: 'B Long', field: 'bLong', width: 100 },
  { label: 'B Note', field: 'bNote', width: 150 },
  { label: 'C Name', field: 'cName', width: 100 },
  { label: 'C Phone', field: 'cPhone', width: 100 },
  { label: 'C Location', field: 'cLocation', width: 220 },
  { label: 'C Lat', field: 'cLat', width: 100 },
  { label: 'C Long', field: 'cLong', width: 100 },
  { label: 'C Note', field: 'cNote', width: 150 },
  { label: 'Language1', field: 'language1', width: 100 },
  { label: 'Language2', field: 'language2', width: 100 },
  { label: 'Info For Driver', field: 'infoForDriver', width: 150, isReadMore: true, maxLength: 60 },
  { label: 'Ride Type', field: 'rideType', width: 90, isCapitalize: true },
  { label: 'Operator Note', field: 'operatorNote', width: 250, isReadMore: true, maxLength: 60 },
  { label: 'Management Note', field: 'managementNote', width: 250, isReadMore: true, maxLength: 60 },
  { label: 'Food Note', field: 'foodNote', width: 200, isReadMore: true, maxLength: 60 },
  { label: 'Customer Note', field: 'note', width: 200, isReadMore: true, maxLength: 60 },
  { label: 'noAdditionalInfo', field: 'noAdditionalInfo', width: 100 },
  { label: 'isNeedHelp', field: 'isNeedHelp', width: 100 },
  { label: 'isNoBigCars', field: 'isNoBigCars', width: 100 },
  { label: 'isNoSmallCars', field: 'isNoSmallCars', width: 100 },
  { label: 'isVisuallyImpaired', field: 'isVisuallyImpaired', width: 100 },
  { label: 'isCane', field: 'isCane', width: 100 },
  { label: 'isElbowAssist', field: 'isElbowAssist', width: 100 },
  { label: 'isTraveling', field: 'isTraveling', width: 100 },
  { label: 'isWalker', field: 'isWalker', width: 100 },
  { label: 'isWheelchair', field: 'isWheelchair', width: 100 },
  { label: 'isHardOfHearing', field: 'isHardOfHearing', width: 100 },
  { label: 'isServiceDog', field: 'isServiceDog', width: 100 },
  { label: 'isOxygenTank', field: 'isOxygenTank', width: 100 },
  { label: 'isPoorMemory', field: 'isPoorMemory', width: 100 },
  { label: 'isAlwaysOperator', field: 'isAlwaysOperator', width: 100 },
  { label: 'isSpeech', field: 'isSpeech', width: 100 },
  { label: 'isHighAlerts', field: 'isHighAlerts', width: 100 },
  { label: 'isVerballyImpaired', field: 'isVerballyImpaired', width: 100 },
  { label: 'isScheduledRideReminderCalls', field: 'isScheduledRideReminderCalls', width: 120 },
  { label: 'isDisableTutorialPlay', field: 'isDisableTutorialPlay', width: 100 },
  { label: 'flagged', field: 'flagged', width: 80 },
  { label: 'credits', field: 'credits', width: 100 },
  { label: 'CC Name', field: 'ccName', width: 100 },
  { label: 'CC Brand', field: 'ccBrand', width: 100 },
  { label: 'CC Funding', field: 'ccFunding', width: 120 },
  { label: 'CC Last4Digits', field: 'ccLast4Digits', width: 130 },
  { label: 'CC Exp', field: 'ccExp', width: 80 },
  { label: 'CC Zip', field: 'ccZip', width: 80 },
  { label: 'Billing Address', field: 'ccBillingAddress', width: 220 },
  { label: 'langPrefForUI', field: 'langPrefForUI', width: 170 },
  { label: 'langPrefForOperator', field: 'langPrefForOperator', width: 170 },
  { label: 'langPrefForDriver', field: 'langPrefForDriver', width: 170 },
  { label: 'Hear About Us', field: 'hearAboutUs', width: 150 },
  { label: 'numberOfUnpaidRides', field: 'numberOfUnpaidRides', width: 100 },
  { label: 'referralCode', field: 'referralCode', width: 100 },
  { label: 'promoId', field: 'promoId', width: 100 },
  { label: 'sentPrintedInvoice', field: 'sentPrintedInvoice', width: 100 },
  { label: 'isNoRedMeat', field: 'isNoRedMeat', width: 100 },
  { label: 'isNutAllergy', field: 'isNutAllergy', width: 100 },
  { label: 'isDairyAllergy', field: 'isDairyAllergy', width: 100 },
  { label: 'isGlutenFree', field: 'isGlutenFree', width: 100 },
  { label: 'isVegan', field: 'isVegan', width: 100 },
  { label: 'isVegetarian', field: 'isVegetarian', width: 100 },
  { label: 'isLowSugarDiet', field: 'isLowSugarDiet', width: 100 },
  { label: 'isLowFatsDiet', field: 'isLowFatsDiet', width: 100 },
  { label: 'isLowFiberDiet', field: 'isLowFiberDiet', width: 100 },
];

export const callerTableColumnsInPartnerDB: TableColumnType[] = [
  { label: 'No', field: 'index', width: 60, isCenterAlign: true },
  { label: 'CallerId', field: 'id', width: 200 },
  { label: 'External Caller ID', field: 'externalPartnerCallerId', width: 200 },
  { label: 'Name', field: 'name', width: 200 },
  { label: 'Phone Number', field: 'phoneNumber', width: 120 },
  { label: 'Phone Number2', field: 'phoneNumber2', width: 120 },
  { label: 'Home Number', field: 'homeNumber', width: 120 },
  { label: 'E-Mail', field: 'email', width: 200 },
  { label: 'Birthday', field: 'dob', width: 100 },
  { label: 'Family Phone', field: 'familyPhoneNumber', width: 120 },
  { label: 'Family E-Mail', field: 'familyEmail', width: 200 },
  { label: 'Family Name', field: 'familyName', width: 150 },
  { label: 'Home Address', field: 'homeAddress', width: 200 },
  { label: 'Mailing Address', field: 'mailingAddress', width: 200 },
  { label: 'RideHomeNote', field: 'homeNote', width: 200 },
  { label: 'GourmetHomeNote', field: 'gourmetHomeNote', width: 200 },
  { label: 'Info For Driver', field: 'infoForDriver', width: 200 },
  { label: 'A Name', field: 'aName', width: 120 },
  { label: 'A Phone', field: 'aPhone', width: 120 },
  { label: 'A Location', field: 'aLocation', width: 250 },
  { label: 'A Note', field: 'aNote', width: 200 },
  { label: 'B Name', field: 'bName', width: 120 },
  { label: 'B Phone', field: 'bPhone', width: 120 },
  { label: 'B Location', field: 'bLocation', width: 250 },
  { label: 'B Note', field: 'bNote', width: 200 },
  { label: 'C Name', field: 'cName', width: 120 },
  { label: 'C Phone', field: 'cPhone', width: 120 },
  { label: 'C Location', field: 'cLocation', width: 250 },
  { label: 'C Note', field: 'cNote', width: 200 },
  { label: 'Date Joined', field: 'createdAt', width: 180, isDateField: true },
  { label: 'Credits', field: 'credits', width: 100 },
  { label: 'Is No Big Cars', field: 'isNoBigCars', width: 100 },
  { label: 'Is Visually Impaired', field: 'isVisuallyImpaired', width: 100 },
  { label: 'Is Cane', field: 'isCane', width: 100 },
  { label: 'Is Elbow Assist', field: 'isElbowAssist', width: 100 },
  { label: 'Is Traveling', field: 'isTraveling', width: 100 },
  { label: 'Is Walker', field: 'isWalker', width: 100 },
  { label: 'Is Wheelchair', field: 'isWheelchair', width: 100 },
  { label: 'Is Hard Of Hearing', field: 'isHardOfHearing', width: 100 },
  { label: 'Is Service Dog', field: 'isServiceDog', width: 100 },
  { label: 'Is Oxygen Tank', field: 'isOxygenTank', width: 100 },
  { label: 'Is Poor Memory', field: 'isPoorMemory', width: 100 },
  { label: 'Is Verbally Impaired', field: 'isVerballyImpaired', width: 100 },
  { label: 'Partner Credits', field: 'partnerCredits', width: 120 },
  { label: 'Partner Rides', field: 'partnerRides', width: 120 },
  { label: 'Partner Notes', field: 'partnerNote', width: 250, isReadMore: true, maxLength: 60 },
  { label: 'Partner Emergency Contact Phone Number', field: 'partnerEmergencyContactPhoneNumber', width: 200 },
  { label: 'Partner Emergency Contact Email', field: 'partnerEmergencyContactEmail', width: 200 },
];

/** Partner-caller fields `callers/search` can return as columns; sections and contact names have no column. */
export const PARTNER_CALLER_SEARCH_COLUMNS = [
  'externalPartnerCallerId',
  'preAuthorizationNumber',
  'partnerServiceCode',
  'partnerBeginningDate',
  'partnerSuspensionDate',
  'partnerMonthlyBudgetAmount',
  'partnerTotalBudgetAmount',
  'partnerEmergencyContactPhoneNumber',
  'partnerEmergencyContactEmail',
];

export const DIAMOND_BAR_SEARCH_PARTNERS = [PartnerCodeName.DIAMOND_BAR, PartnerCodeName.DEMO];

export const SUSPENSION_PERIOD_FIELDS = ['timePlanSuspendPeriodStartDate', 'timePlanSuspendPeriodEndDate'];

const suspensionPeriodColumns: TableColumnType[] = [
  { label: 'Suspend Starts At', field: SUSPENSION_PERIOD_FIELDS[0], width: 160 },
  { label: 'Suspend Ends At', field: SUSPENSION_PERIOD_FIELDS[1], width: 160 },
];

export const partnerExtraCallerTableColumnsInPartnerDB: Record<string, TableColumnType[]> = {
  ...Object.fromEntries(DIAMOND_BAR_SEARCH_PARTNERS.map((codeName) => [codeName, suspensionPeriodColumns])),
  [PartnerCodeName.ACRC]: [
    { label: 'Pre-authorization #', field: 'preAuthorizationNumber', width: 200 },
    { label: 'Suspension Date', field: 'partnerSuspensionDate', width: 200 },
  ],
  [PartnerCodeName.ORIONISO]: [{ label: 'Suspension Date', field: 'partnerSuspensionDate', width: 200 }],
  [PartnerCodeName.ACEFMS]: [
    { label: 'Pre-authorization #', field: 'preAuthorizationNumber', width: 200 },
    { label: 'Suspension Date', field: 'partnerSuspensionDate', width: 200 },
    { label: 'Service Code', field: 'partnerServiceCode', width: 100 },
  ],
};
export const callerTableColumnsInAffiliateDB: TableColumnType[] = [
  { label: 'No', field: 'index', width: 60, isCenterAlign: true },
  { label: 'Name', field: 'name', width: 150 },
  { label: 'Caller ID', field: 'id', width: 200 },
  { label: 'Created At', field: 'createdAt', width: 180, isDateField: true },
  { label: 'Active', field: 'isActive', width: 80 },
  { label: 'Deactivation Reason', field: 'deactivationReason', width: 220 },
  { label: 'Phone Number', field: 'phoneNumber', width: 120 },
  { label: 'Email', field: 'email', width: 200 },
  { label: 'Street Address', field: 'streetAddress', width: 150 },
  { label: 'Street Address2', field: 'streetAddress2', width: 120 },
  { label: 'City', field: 'city', width: 100 },
  { label: 'State', field: 'state', width: 80 },
  { label: 'Zip', field: 'zip', width: 80 },
  { label: 'Country', field: 'country', width: 90 },
  { label: 'Lat', field: 'latitude', width: 100 },
  { label: 'Lng', field: 'longitude', width: 100 },
  { label: 'TimeZone', field: 'timeZone', width: 160 },
];

export const accountClosingReasonList: ListType[] = [
  { id: 1, key: 'Account setup for one-time use', label: 'Account setup for one-time use' },
  { id: 2, key: "Can't guarantee coverage", label: "Can't guarantee coverage" },
  { id: 3, key: "Can't guarantee drivers will assist", label: "Can't guarantee drivers will assist" },
  { id: 4, key: 'Changed their mind after signing-up', label: 'Changed their mind after signing-up' },
  { id: 5, key: 'Changing the Billing Cycle/Renewal Date', label: 'Changing the Billing Cycle/Renewal Date' },
  { id: 6, key: 'Cost', label: 'Cost' },
  { id: 7, key: 'Driver reason', label: 'Driver reason' },
  { id: 8, key: 'Duplicate account', label: 'Duplicate account' },
  { id: 9, key: 'Found alternative transportation', label: 'Found alternative transportation' },
  { id: 10, key: 'Fraud/Blacklisted', label: 'Fraud/Blacklisted' },
  { id: 11, key: 'Medical reason/illness', label: 'Medical reason/illness' },
  { id: 12, key: 'Membership fee', label: 'Membership fee' },
  { id: 13, key: 'No reason provided/Unavailable', label: 'No reason provided/Unavailable' },
  { id: 14, key: 'Not using/Does not need the service', label: 'Not using/Does not need the service' },
  { id: 15, key: 'Operator reason', label: 'Operator reason' },
  { id: 16, key: 'Other', label: 'Other' },
  { id: 17, key: 'Partnerships', label: 'Partnerships' },
  { id: 18, key: 'Passed away', label: 'Passed away' },
  { id: 19, key: 'Started driving again', label: 'Started driving again' },
  { id: 20, key: 'Started using Uber/Lyft directly', label: 'Started using Uber/Lyft directly' },
  { id: 21, key: 'System/Services issues or complications', label: 'System/Services issues or complications' },
  {
    id: 22,
    key: 'Voicemail - Member still needs to be contacted for retention',
    label: 'Voicemail - Member still needs to be contacted for retention',
  },
];

export enum ImmediatelyAccountclosingReasonList {
  MedicalReason = 'Medical reason/illness',
  PassedAway = 'Passed away',
  DuplicateAccount = 'Duplicate account',
  Fraud = 'Fraud/Blacklisted',
}

export const musicGenreList: ListType[] = [
  { id: 1, key: 'oldies', label: 'Oldies' },
  { id: 2, key: 'classical', label: 'Classical' },
  { id: 3, key: 'classicRock', label: 'Classic Rock' },
  { id: 4, key: 'soul', label: 'Soul' },
  { id: 5, key: 'jazz', label: 'Jazz' },
  { id: 6, key: 'relaxingNatureSounds', label: 'Relaxing Nature Sounds' },
  { id: 7, key: 'christmas', label: 'Christmas' },
  { id: 8, key: 'none', label: 'Default' },
];

export const flaggedTypes: ListType[] = [
  { id: FlaggedUserType.NotFlagged, key: 'Not Flagged', label: 'Not Flagged' },
  { id: FlaggedUserType.FraudUser, key: 'Fraud User', label: 'Fraud User' },
  { id: FlaggedUserType.NeverFraudAgain, key: 'Never mark this user as fraud again', label: 'Never mark this user as fraud again' },
  { id: FlaggedUserType.NeedsToClearDisputes, key: 'Needs to clear disputes', label: 'Needs to clear disputes' },
];

export const languagePreferenceList: ListType[] = [
  { id: 0, key: 'noPreference', label: 'No Preference' },
  { id: 3, key: 'prefersLanguage1', label: 'Prefers Primary Language' },
  { id: 2, key: 'requiresLanguage1', label: 'Requires Primary Language' },
  { id: 5, key: 'prefersLanguage2', label: 'Prefers Secondary Language' },
  { id: 4, key: 'requiresLanguage2', label: 'Requires Secondary Language' },
];

export const hearAboutList: ListType[] = [
  { id: 1, key: '211', label: '211' },
  { id: 2, key: 'attorney', label: 'Attorney' },
  { id: 3, key: 'Bing', label: 'Bing' },
  { id: 4, key: 'caregiver', label: 'Caregiver' },
  { id: 5, key: 'church', label: 'Church' },
  { id: 6, key: 'communityCenter', label: 'Community Center' },
  { id: 7, key: 'medical', label: "Doctor's Office" },
  { id: 8, key: 'email', label: 'Email' },
  { id: 9, key: 'Facebook', label: 'Facebook' },
  { id: 10, key: 'family', label: 'Family member told me' },
  { id: 11, key: 'friends', label: 'Friend told me' },
  { id: 12, key: 'GoGoEmail', label: 'GoGoGrandparent email/newsletter' },
  { id: 13, key: 'Google', label: 'Google' },
  { id: 14, key: 'government', label: 'Government Agency' },
  { id: 15, key: 'hair salon', label: 'Hair Salon' },
  {
    id: 16,
    key: 'hospital or clinic',
    label: 'Hospital or Clinic',
    children: [
      { id: 160, key: 'hospital', label: 'Hospital' },
      { id: 161, key: 'clinic', label: 'Dialysis Clinic' },
      { id: 162, key: 'urgentCare', label: 'Urgent Care' },
      { id: 163, key: 'therapyBalanceCenter', label: 'Therapy & Balance Center' },
      { id: 164, key: 'eyeDoctor', label: 'Eye Doctor' },
      { id: 165, key: 'dentist', label: 'Dentist' },
      { id: 166, key: 'orthopedic', label: 'Orthopedic (bones/muscles)' },
      { id: 167, key: 'rehabilitationHospital', label: 'Rehabilitation Hospital' },
    ],
  },
  {
    id: 17,
    key: 'mailer',
    label: 'Mailer',
    children: [
      { id: 170, key: 'valpak', label: 'Valpak - Blue Envelope' },
      { id: 171, key: 'vericast', label: 'Save Spend Happy coupons (Vericast)' },
      { id: 172, key: 'premierHome', label: 'Premier Home and Lifestyle coupons' },
    ],
  },
  { id: 18, key: 'newspaper', label: 'Newspaper' },
  { id: 19, key: 'NextDoor', label: 'NextDoor' },
  { id: 20, key: 'other', label: 'Other' },
  { id: 21, key: 'nonprofit', label: 'Other Non-Profit' },
  { id: 22, key: 'online', label: 'Other website' },
  { id: 23, key: 'postcard', label: 'Post card from friend/family member' },
  { id: 24, key: 'ProductHunt', label: 'Product Hunt' },
  { id: 25, key: 'Reddit', label: 'Reddit' },
  { id: 26, key: 'retirementCommunity', label: 'Retirement Community' },
  { id: 27, key: 'social club', label: 'Social club' },
  { id: 28, key: 'socialworker', label: 'Social Worker' },
  { id: 29, key: 'TechCrunch', label: 'TechCrunch' },
  { id: 30, key: 'television', label: 'Television' },
  { id: 31, key: 'transitAgency', label: 'Transit Agency' },
  { id: 32, key: 'UMass partnership', label: 'UMass partnership' },
];

export const reactivateTypeList: ListType[] = [
  { id: 1, key: '', label: 'With Existing Credit/Debit Card' },
  { id: 1, key: 'credit-card', label: 'Add Credit/Debit Card' },
  { id: 2, key: 'gogo-credits', label: 'Add GoGo Credits' },
];

export const minAge = 18;
export const maxAge = 120;
